import Draggable from 'vuedraggable';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('draggable', Draggable)
})